<p-table [columns]="fileProcessingHeaders" [value]="_masterLists" selectionMode="single"
  [(selection)]="selectedInboundProcessing" (onRowSelect)="handleRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let fileProcessingField of columns">
        <ng-template [ngIf]="fileProcessingField.showInGrid">
          <th id="{{fileProcessingField.field+'Column'}}"
            [pSortableColumn]="fileProcessingField.field == 'lab' ? fileProcessingField.sort:fileProcessingField.field">
            {{fileProcessingField.header}}
            <p-sortIcon
              [field]="fileProcessingField.field == 'lab' ? fileProcessingField.sort:fileProcessingField.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let fileProcessingCol of columns">
        <ng-template [ngIf]="fileProcessingCol.showInGrid">
          <td *ngIf="fileProcessingCol.field != 'lab'  && fileProcessingCol.field != 'active'" class="wrapword">
            {{rowData[fileProcessingCol.field]}}
          </td>
          <td *ngIf="fileProcessingCol.field == 'active'">
            <p-checkbox disabled [(ngModel)]="rowData[fileProcessingCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="fileProcessingCol.field=='lab'">
            {{rowData[fileProcessingCol.field]!= null? rowData[fileProcessingCol.field].name :''}}
          </td>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="handleAddNewInboundFileProcessing()" style="height: 35px;"
        label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="showInboundFileProcessingDialog" [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style.width]="'800px'" position="top"
  (onHide)="this.showInboundFileProcessingDialog = false;" baseZIndex="10">
  <div *ngIf="inboundFileProcessing">
    <div *ngFor="let fileProcessingField of fileProcessingHeaders">
      <div class="form-group m-2">
        <div>
          <label>{{fileProcessingField.header}}</label>
        </div>
        <div *ngIf="fileProcessingField.field == 'name' || fileProcessingField.field == 'location'">
          <input pInputText class="form-control" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            [ngClass]="{error:inboundFileProcessing[fileProcessingField.field+'Error']}"
            [placeholder]="fileProcessingField.header">
        </div>
        <div *ngIf="fileProcessingField.field == 'lab'">
          <p-dropdown [options]="_labOptions" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            [filter]="true" placeholder="Select a Lab" optionLabel="name" [showClear]="true"
            [styleClass]="inboundFileProcessing[fileProcessingField.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="fileProcessingField.field == 'handler'">
          <p-dropdown [options]="handlers" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            [filter]="true" placeholder="Select Handler" optionLabel="name" [showClear]="true" [autoDisplayFirst]="true"
            [styleClass]="inboundFileProcessing[fileProcessingField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="fileProcessingField.field == 'success'">
          <p-dropdown [options]="successList" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            [filter]="true" placeholder="Select successfull status" optionLabel="name" [showClear]="true"
            [autoDisplayFirst]="true"
            [styleClass]="inboundFileProcessing[fileProcessingField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="fileProcessingField.field == 'unsuccess'">
          <p-dropdown [options]="unsuccessList" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            [filter]="true" placeholder="Select unsuccessfull status" optionLabel="name" [showClear]="true"
            [autoDisplayFirst]="true"
            [styleClass]="inboundFileProcessing[fileProcessingField.field+'Error']?'error':''">
          </p-dropdown>
        </div>
        <div *ngIf="fileProcessingField.field == 'allowedStatus'">
          <p-multiSelect [options]="allowedStatusList" [style]="{'min-width':'8vw','max-width':'20vw'}"
            [(ngModel)]="selectedAllowedStatusList" [filter]="true" placeholder="Select Allowed status"
            optionLabel="name" [styleClass]="inboundFileProcessing[fileProcessingField.field+'Error']?'error':''">
          </p-multiSelect>
        </div>
        <div *ngIf="fileProcessingField.field == 'active'">
          <p-checkbox id="active" [(ngModel)]="inboundFileProcessing[fileProcessingField.field]"
            binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="false" (click)="handleSaveOrUpdate()" label="Save"
      style="float: right; height: 35px;"></button>
  </div>
</p-dialog>